import React from "react";
import HelmetWrapper from "../HelmetWrapper";
import "../styles/animations.css";
// import backgroundImage from "../images/common/body-bg1.jpg";
// import { WTFNewRoundLogo } from "../exports/Images";
import LayoutMenus from "../components/layout-home/LayoutMenus";

const LayoutHome = () => {
  // useEffect(() => {
  //   document.body.style.backgroundImage = `url(${backgroundImage})`;
  //   document.body.style.backgroundSize = "cover";
  //   document.body.style.backgroundPosition = "center";
  //   document.body.style.backgroundRepeat = "no-repeat";
  //   document.body.style.height = "100vh";
  //   document.body.style.width = "100vw";

  //   return () => {
  //     document.body.style.backgroundImage = "";
  //     document.body.style.backgroundSize = "";
  //     document.body.style.backgroundPosition = "";
  //     document.body.style.backgroundRepeat = "";
  //     document.body.style.height = "";
  //     document.body.style.width = "";
  //   };
  // }, []);

  return (
    <HelmetWrapper title="WTF: Dashboard">
      <LayoutMenus />
      {/* <div className="layout-container">
        <img src={WTFNewRoundLogo} alt="WTF" className="wtf-logo-center" />
      </div> */}
    </HelmetWrapper>
  );
};

export default LayoutHome;
